export default "__VITE_ASSET__CnUEe78r__"